module.exports = __webpack_public_path__ + "img/ss1.430f16dc.jpg";